"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptPaymentService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class AcceptPaymentService {
    /**
     * Accept stripe hooks
     * @returns any No response body
     * @throws ApiError
     */
    static acceptPaymentStripeCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/accept_payment/stripe/',
        });
    }
}
exports.AcceptPaymentService = AcceptPaymentService;
